import { render, staticRenderFns } from "./CommodityDetail.vue?vue&type=template&id=41b4e78f&scoped=true"
import script from "./CommodityDetail.vue?vue&type=script&lang=js"
export * from "./CommodityDetail.vue?vue&type=script&lang=js"
import style0 from "./CommodityDetail.vue?vue&type=style&index=0&id=41b4e78f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4e78f",
  null
  
)

export default component.exports